import React from 'react';
import { VerticalTabsItem } from '../VerticalTabsItem';
import { VerticalTabsContext } from './VerticalTabsContext';
import {
  TabsGroupProps,
  VerticalTabsProps,
  VerticalTabsFooterProps,
} from './VerticalTabs.types';
import { SIZE, SKIN } from './VerticalTabs.constants';
import { VerticalTabsIconItem } from '../VerticalTabsIconItem';
import { useTabNavigation } from '../common/useTabNavigation';
import { classes } from './VerticalTabs.st.css';

/** Vertical tabs navigation panel. */
const Footer = ({ children }: VerticalTabsFooterProps) => (
  <VerticalTabsItem type="action">{children}</VerticalTabsItem>
);

const TabsGroup = ({ title = '', children }: TabsGroupProps) => (
  <>
    <VerticalTabsItem type="title">{title}</VerticalTabsItem>
    {children}
  </>
);

const VerticalTabs = <TabId extends string | number = number>({
  dataHook,
  children,
  size = SIZE.MEDIUM,
  skin = SKIN.LIGHT,
  activeTabId,
  ellipsis = false,
  maxWidth,
  onChange,
}: VerticalTabsProps<TabId>) => {
  const tabNavigationRef = useTabNavigation({ orientation: 'vertical' });

  return (
    <VerticalTabsContext.Provider
      // @ts-expect-error - didn't manage to make context work with components generics
      value={{ size, skin, activeTabId, ellipsis, onChange }}
    >
      <div
        className={classes.root}
        data-hook={dataHook}
        aria-orientation="vertical"
        role="tablist"
        style={{ maxWidth }}
        data-active-tab-id={activeTabId}
        ref={tabNavigationRef}
      >
        {children}
      </div>
    </VerticalTabsContext.Provider>
  );
};

VerticalTabs.TabsGroup = TabsGroup;
VerticalTabs.TabItem = VerticalTabsItem;
VerticalTabs.IconItem = VerticalTabsIconItem;
VerticalTabs.Footer = Footer;
VerticalTabs.displayName = 'VerticalTabs';
export { VerticalTabs };
